"use strict";
function eventExperienceService(service={},visitType){
 const options=Array.isArray(service.visitTypeOptions)?service.visitTypeOptions:[];
 const selected=options.find(option=>option.enabled!==false&&String(option.id)===String(visitType));
 if(!selected)return service;
 const type=selected.priceType||selected.pricingType||service.priceType||service.pricingType||'fixed';
 return {...service,priceType:type,pricingType:type};
}
module.exports={eventExperienceService};
